module.exports = __webpack_public_path__ + "img/img-weight.ffbe2698.png";